import { render, staticRenderFns } from "./PersistentSearch.vue?vue&type=template&id=6c59a178&scoped=true&"
import script from "./PersistentSearch.vue?vue&type=script&lang=js&"
export * from "./PersistentSearch.vue?vue&type=script&lang=js&"
import style0 from "./PersistentSearch.vue?vue&type=style&index=0&id=6c59a178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c59a178",
  null
  
)

export default component.exports